import { CLOSE_SIDE_PANE, OPEN_SIDE_PANE } from '../actions/sidePaneActions';
var initialState = getDefaultState();
export default function sidePane() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var payload = _ref.payload,
    type = _ref.type;
  switch (type) {
    case CLOSE_SIDE_PANE:
      return getDefaultState();
    case OPEN_SIDE_PANE:
      return {
        isOpen: true,
        name: payload.pane,
        data: payload.sidePaneProps
      };
    default:
      return state;
  }
}
export function getDefaultState() {
  return {
    isOpen: false,
    name: '',
    data: {}
  };
}